import { useTranslation } from 'react-i18next';
import FormLangBar from '../../FormLangBar';
import { MwInputText,MwTextArea,MwSwitch } from '../../ui';
import {
    PRODUCT_FORM_SECTION_CLASS,
    PRODUCT_OPTION_LABEL_CLASS,
    PRODUCT_OPTION_ROW_CLASS,
} from '../productUi';

const BrandForm = ({
    currentLangList,
    formLang,
    setFormLang,
    errors,
    brandName,
    setBrandName,
    brandDesc,
    setBrandDesc,
    brandMetaKeywords,
    setBrandMetaKeywords,
    isShowOnWebsite,
    setIsShowOnWebsite,
    isActive,
    setIsActive
}) => {
    const [t] = useTranslation('global')
    return (
        <form className='space-y-4'>
            <div id='MultiLangBlock' className='flex flex-col'>
                <FormLangBar currentLangList = {currentLangList} formLang = {formLang} setFormLang = {setFormLang} />
                { currentLangList.map((lang) => (
                    <div key={lang.langCode} className={`${PRODUCT_FORM_SECTION_CLASS} ${formLang === lang?.langCode ? 'block' : 'hidden'}`}>
                        <MwInputText
                            label={`${t('product.brand_name_label')} (${lang?.langName})`}
                            id={`brandName${lang?.langCode}`} 
                            placeholder={`${t('product.brand_name_label')} (${lang?.langName})`}
                            value={brandName[lang?.langCode]}
                            invalid={!!errors[`brandName.${lang?.langCode}`] }
                            invalidMsg={errors[`brandName.${lang?.langCode}`]}
                            onChange={(e)=>{
                                setBrandName({...brandName, [lang?.langCode]:e.target.value});
                            }}
                        />
                        <div className='mt-3'>
                            <MwTextArea
                                id={`brandDesc${lang?.langCode}`}
                                label={`${t('product.brand_desc_placeholder')} (${lang.langName})`}
                                value={brandDesc[lang?.langCode]}
                                placeholder={`${t('product.brand_desc_placeholder')} (${lang.langName})`}
                                rows={4}
                                onChange={(e ) => setBrandDesc({...brandDesc,[lang?.langCode]:e.target.value})}
                            />
                        </div>
                        <div className='mt-3'>
                            <MwTextArea
                                id={`brandMetaKeywords${lang?.langCode}`}
                                label={`${t('product.seo_keywords_placeholder')} (${lang.langName})`}
                                value={brandMetaKeywords[lang?.langCode]}
                                placeholder={`${t('product.seo_keywords_placeholder')} (${lang.langName})`}
                                rows={4}
                                onChange={(e ) => setBrandMetaKeywords({...brandMetaKeywords,[lang?.langCode]:e.target.value})}
                            />
                        </div>
                    </div>
                )) }
            </div>
            <div id='OptionsBock' className='flex flex-col gap-3'>
                <div className={PRODUCT_OPTION_ROW_CLASS}>
                    <label className={PRODUCT_OPTION_LABEL_CLASS}>{t('product.website_visibility')}</label>
                    <MwSwitch custKey='isActive' isActive={isShowOnWebsite} setIsActive={setIsShowOnWebsite} onChangeSwitch={()=> setIsShowOnWebsite(!isShowOnWebsite)} />
                </div>
                <div className={PRODUCT_OPTION_ROW_CLASS}>
                    <label className={PRODUCT_OPTION_LABEL_CLASS}>{t('product.activation_status')}</label>
                    <MwSwitch custKey='isActive' isActive={isActive} setIsActive={setIsActive} onChangeSwitch={() => setIsActive(!isActive)} />
                </div>
            </div>
        </form>
    )
}

export default BrandForm
